import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const WelcomeModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem('amrutMahotsavModalSeen');
    if (!hasSeenModal) {
      setTimeout(() => setIsOpen(true), 500);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem('amrutMahotsavModalSeen', 'true');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black bg-opacity-70 backdrop-blur-sm" data-testid="welcome-modal">
      <div className="relative max-w-4xl w-full bg-white rounded-2xl shadow-2xl overflow-hidden zoom-in">
        <button
          onClick={handleClose}
          data-testid="welcome-modal-close"
          className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-gray-100 transition-colors"
        >
          <X size={20} />
        </button>

        <div className="flex flex-col md:flex-row">
          {/* Image Section */}
          <div className="md:w-1/2 h-64 md:h-auto">
            <img
              src="https://images.unsplash.com/photo-1687709644312-8c67bd4821c6"
              alt="JG Group Campus"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content Section */}
          <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center">
            <div className="text-center">
              <div className="inline-block px-6 py-2 rounded-full bg-gradient-to-r from-orange-500 to-green-600 text-white font-bold text-sm mb-4">
                Celebrating 75 Years
              </div>
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gradient">
                Amrut Mahotsav
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-orange-500 via-gold-500 to-green-600 mx-auto mb-6"></div>
              <p className="text-gray-700 text-lg mb-6 leading-relaxed">
                Join us in celebrating <span className="font-bold text-orange-600">75 glorious years</span> of JG Group's legacy in education, innovation, and nation-building.
              </p>
              <p className="text-gray-600 mb-8">
                A journey of excellence, dedication, and service to the nation.
              </p>
              <button
                onClick={handleClose}
                data-testid="welcome-modal-enter-btn"
                className="btn-primary inline-block"
              >
                Enter Celebration
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;